<template>
  <div v-if="rows.length" class="box py-2 skill-answers" dir="rtl" data-test="skill-answers">
    <p class="has-text-weight-bold mb-1">כישורים (תשובות המועמד)</p>
    <ul class="is-size-7">
      <li
        v-for="row in rows"
        :key="row.key"
        :class="{ 'has-text-grey-light': row.expired, 'is-clickable': row.detail }"
        data-test="skill-answer-row"
        @click="toggle(row)"
      >
        <span :class="row.expired ? '' : (row.has ? 'has-text-success' : 'has-text-danger')" data-test="skill-answer-mark">{{ row.has ? '✓' : '✗' }}</span>
        <span> {{ row.name }}</span>
        <span v-if="row.date" class="has-text-grey"> · {{ row.date }}</span>
        <span v-if="row.expired" class="tag is-light is-small mr-1" data-test="skill-answer-expired">פג תוקף</span>
        <span v-if="row.detail" class="has-text-link"> · {{ openKey === row.key ? 'הסתר' : 'פרטים' }}</span>
        <p v-if="row.detail && openKey === row.key" class="skill-answer-detail has-text-dark" data-test="skill-answer-detail">{{ row.detail }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { formatDate } from '@/custom/helpers/format_date'

// VA2 - the candidate's yes/no skill answers from the chatbot
// (applicant.skill_answers). Expired answers (valid === false) are greyed.
// "detail" opens inline on click (no hover, no floating UI).
export default {
  name: 'SkillAnswers',
  props: {
    skillAnswers: { type: Array, default: () => [] }
  },
  data () {
    return { openKey: null }
  },
  computed: {
    rows () {
      return (Array.isArray(this.skillAnswers) ? this.skillAnswers : [])
        .filter(a => a && (a.skill_name || a.skill_id) && a.has_skill !== null && a.has_skill !== undefined)
        .map((a, i) => ({
          key: `${a.skill_id || a.skill_name}-${i}`,
          name: a.skill_name || `#${a.skill_id}`,
          has: a.has_skill === true || a.has_skill === 'true',
          date: formatDate(a.answered_at),
          expired: a.valid === false,
          detail: a.detail ? String(a.detail) : ''
        }))
    }
  },
  methods: {
    toggle (row) {
      if (!row.detail) return
      this.openKey = this.openKey === row.key ? null : row.key
    }
  }
}
</script>

<style scoped>
.skill-answers ul { margin: 0; }
.skill-answers li { line-height: 1.6; }
.skill-answer-detail { margin: 0 1.2em 0.2em 0; white-space: pre-line; }
</style>
